module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./AllPostView.jsx"));
	}, "AllPost");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AllPost!./src/pages/bundle-org-mgmt/AllPost/AllPostView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=AllPost!./src/pages/bundle-org-mgmt/AllPost/AllPostView.jsx
// module chunks = 43